import { createSelector } from "@reduxjs/toolkit";

const getLocation = (state) =>
	(state.location.item && state.location.item.location) || [];

export const getLocationSelector = createSelector(getLocation, (location) => {
	return location;
});

export function makeGetLocationSelector() {
	return getLocationSelector;
}
